<template>
    <div class="container-fluid mt-4 mb-4" style="min-height: 50vh">
        <h1 class="h1 mt-5 mb-4">
            Account Setup
        </h1>

        <b-card>
            <b-table
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="consts.general.rows_per_page"
              striped
              :busy="loading"
              show-empty
              id="device-table">
              <template slot="id" slot-scope="device">
                  <router-link
                      :to="{ name: 'device_detail', params: { id: device.item.id }}"
                      :id="'device-id-' + device.item.name"
                  >{{device.item.id}}</router-link>
              </template>
            </b-table>
       </b-card>
        <b-row class="mb-2" style="text-align:center">
            <b-col >
                 <b-button @click="finish()"
                    block 
                    variant="light"
                    style="width:40%; margin:auto; height: 48px; padding-top: 11px"
                > <strong> Verify IMEI, Click and Check Email</strong></b-button>
            </b-col>
        </b-row>

    </div>
</template>

<script>
    import { get_device_by_imei } from '../../networking/devices'

    import moment from 'moment'

    const device_fields = [
        { key: 'name' },
        { key: 'device_type_desc', label: 'Device Type' },
        { key: 'iccid', label: 'ICCID' },
        { key: 'imei', label: 'Serial Number' },
    ]


    export default {
        props: {
            imei: { type: String }
        },
        data() {
            return {

                device_id: null,
                moment: moment,
                device: {}, 
                items: [],
                fields: device_fields,
                tableName: 'device',
                tabIndex: 0,
                loading: false,
                currentPage: 1,
                pages: [],
                itemsNotEmpty: false,
                totalRows: 1,
                perPage: 10,
           }
        },


        async created() {
            this.retrieve_device()
        },

        methods: {
            async retrieve_device() {
                this.items = []

                try {
                    const deviceFound = await get_device_by_imei(this.imei)
                    if (deviceFound.value.data) {
                        if (deviceFound.value.data.length === 0) {
                            this.$emit('showAlert', 'Device not found', 'danger', 5000)
                        }
                        if (deviceFound.value.data.length > 1) {
                            this.$emit('showAlert', 'More than one device found', 'danger', 5000)
                        } else {
                            this.items.push(deviceFound.value.data)
                            this.itemsNotEmpty = true
                            this.totalRows = this.items.length
                            this.currentPage = 1
                        }
                    } else {
                        this.$emit('showAlert', 'Unable to find device', 'danger', 5000)

                    }

                } catch (e) {
                    console.log('error: ', e)
                    if (e.message) {
                        this.$emit('showAlert', e.message, 'danger', 5000)
                    }
                }
            },
            finish(){
                this.$emit('logOut')
                localStorage.clear()
                window.location.replace("http://konametrix.com")
            },
        }
    }

</script>

<style>
    /* If scoped style is not applied: @bug */

    .description-table-col {
        min-width: 180px
    }

    .table-striped tbody tr:nth-of-type(odd) {
        background: rgba(132, 171, 207, 0.12) !important /* TO DO: Find a nicer color */
    }
</style>



